import { useTranslation } from 'react-i18next'

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation()

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'zh' : 'en'
    i18n.changeLanguage(newLang)
  }

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-1.5 rounded border border-crafter-accent/20 hover:bg-crafter-accent/10 transition-colors"
      aria-label="Toggle language"
    >
      <span className="font-mono text-sm text-crafter-text">
        {i18n.language === 'en' ? t('language.en') : t('language.zh')}
      </span>
      <svg
        className="w-4 h-4 text-crafter-accent"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  )
}
